import React from "react";
import f from "./footer.module.css";

export default function footer({
  toggle,
  currentPage,
  gamesPerPage,
  total,
  pagination,
}) {
  const numberPgs = [];

  for (let i = 1; i <= Math.ceil(total / gamesPerPage); i++) {
    numberPgs.push(i);
  }

  const footer = {
    position: "fixed",
    left: " 300px",
    bottom: "0",
    width: " calc(100% - 300px)",
    background: "var(--black)",
    borderTop: "1px solid var(--border)",
    height: "80px",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    zIndex: "100",
    padding: "0 0 0 20px",
    fontSize: "0.6em",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  const footerActive = {
    position: "fixed",
    left: " 0",
    bottom: "0",
    width: "100%",
    background: "var(--black)",
    borderTop: "1px solid var(--border)",
    height: "80px",
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    zIndex: "100",
    padding: "0 0 0 20px",
    fontSize: "0.6em",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  return (
    // <div className={toggle ? f.footer : f.footer.active}>
    <div style={toggle ? footer : footerActive}>
      <div className={f.pagination}>
        <ul className={f.pages}>
          {numberPgs.map((e) => (
            <li
              key={e}
              className={currentPage === e ? `${f.liactive}` : "liactive"}
            >
              <span onClick={() => pagination(e)}>{e}</span>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <a href="#top" className={f.btnUp}>
          {" "}
        </a>
      </div>
    </div>
  );
}
